import { useMergeRefs } from "@floating-ui/react"
import classNames from "classnames"
import type {
  Ref,
  FunctionComponentElement,
  HTMLProps,
} from "react"
import {
  cloneElement,
  useMemo,
} from "react"

export function useCloneElement<E extends Element>(
  element?: FunctionComponentElement<E>,
  props: HTMLProps<E> = {},
): FunctionComponentElement<E> | null {
  const ref = useMergeRefs([
    element?.ref,
    props.ref,
  ] as Array<Ref<unknown>>)

  return useMemo(
    () => {
      if (!element) {
        return null
      }

      return cloneElement<E>(
        element,
        {
          ...element.props,
          ...props,
          className: classNames(
            element.props?.className as (string | undefined),
            props.className,
          ),
          ref,
        },
      )
    },
    [
      element,
      props,
      ref,
    ],
  )
}
